import { baseApi } from './baseApi';

export const dashboardApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getDashboardSummary: builder.query({
      query: () => '/dashboard/summary',
      providesTags: ['Sales', 'Purchase', 'Product', 'Inventory'],
    }),
  }),
});

export const { useGetDashboardSummaryQuery } = dashboardApi;
